(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.ks-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (Shopify.designMode) return
  // Don't open the newsletter popup on product pages — was causing glitchy flashes on PDP load
  if (document.documentElement.getAttribute('data-template') === 'product') return
  if (document.body && document.body.classList.contains('template-product')) return
  if (location.pathname.indexOf('/products/') !== -1) return

  // Create cookie function
  function createCookie (name, value, days) {
    let date, expires
    if (days) {
      date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    } else {
      expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  const dialog = document.querySelector('#ks-newsletter-dialog')

  // Close dialog if clicked outside
  dialog.addEventListener('click', (event) => {
    const withinBoundaries = event.composedPath().includes(dialog.querySelector('.ks-dialog-inner'))

    if (!withinBoundaries) {
      dialog.close() 
    }
  })

  // Close button
  dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
    event.preventDefault()
    dialog.close()
  })

  // Show the dialog if url contains (www.mystore.com/?ks-newsletter-popup)
  if (window.location.href.includes('ks-newsletter-popup')) {
    dialog.showModal() 
    return
  }

  // Do not show the dialog if the cookie is still present (config from settings)
  if (document.cookie.indexOf('ks-newsletter-popup') > -1) {
    return
  }

  (async () => {
    // Show the dialog on page load after some time has passed (config from settings)
    await new Promise(resolve => setTimeout(resolve, Number(dialog.dataset.configDelay) * 1000))

    // Create a cookie so that we don't show the dialog for some time (config from settings)
    createCookie('ks-newsletter-popup', true, Number(dialog.dataset.configDaysToWait))

    dialog.showModal()
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-videos"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    const initSlider = () => {
      if (!window.Swiper) return false
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })
      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
      return true
    }

    let scriptEl = document.querySelector('#swiper-script')
    if (!scriptEl) {
      scriptEl = document.createElement('script')
      scriptEl.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      scriptEl.setAttribute('id', 'swiper-script')
      scriptEl.setAttribute('crossorigin', 'anonymous')
      scriptEl.setAttribute('defer', '')
      document.head.appendChild(scriptEl)
    }

    if (window.Swiper) {
      // Already loaded (multiple sections on page)
      requestAnimationFrame(() => initSlider())
    } else {
      scriptEl.addEventListener('load', () => initSlider(), { once: true })
      // Final safety net: poll briefly in case load event missed
      let tries = 0
      const poll = setInterval(() => {
        tries++
        if (window.Swiper) {
          clearInterval(poll)
          initSlider()
        } else if (tries > 40) {
          clearInterval(poll)
        }
      }, 100)
    }

    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.ks-shoppable-videos-card')
        this.openReels(parseInt(card.dataset.index, 10))
      })
    })

    this.querySelectorAll('.ks-shoppable-videos-card video').forEach(video => {
      video.addEventListener('click', () => {
        const card = video.closest('.ks-shoppable-videos-card')
        this.openReels(parseInt(card.dataset.index, 10))
      })
    })

    this.initReels()

    // Defer to next frame so children + swiper are in DOM, then prep videos for autoplay.
    const setupCarouselAutoplay = () => {
      const cardVideos = this.querySelectorAll('.ks-shoppable-videos-card video')
      if (!cardVideos.length) return
      cardVideos.forEach((v) => {
        // Force the JS properties + attributes that browsers require for muted autoplay
        v.muted = true
        v.defaultMuted = true
        v.loop = true
        v.controls = false
        v.autoplay = true
        v.setAttribute('muted', '')
        v.setAttribute('playsinline', '')
        v.setAttribute('webkit-playsinline', '')
        v.setAttribute('autoplay', '')
        v.removeAttribute('controls')
        // Force the element to begin loading (preload may have been "none")
        if (!v.preload || v.preload === 'none') { v.preload = 'auto'; v.load() }
        const tryPlay = () => {
          const p = v.play()
          if (p && p.catch) p.catch(() => {
            // Autoplay blocked → unblock on first user gesture anywhere on page
            const unblock = () => {
              v.muted = true
              v.play().catch(() => {})
              ['click','touchstart','keydown','scroll'].forEach(ev =>
                document.removeEventListener(ev, unblock, true))
            }
            ['click','touchstart','keydown','scroll'].forEach(ev =>
              document.addEventListener(ev, unblock, { once: true, capture: true }))
          })
        }
        // Multiple attempts at every readiness point
        tryPlay()
        v.addEventListener('loadedmetadata', tryPlay, { once: true })
        v.addEventListener('canplay', tryPlay, { once: true })
        v.addEventListener('canplaythrough', tryPlay, { once: true })
      })

      const lazyVideosObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const v = entry.target
          if (entry.isIntersecting) {
            v.muted = true
            v.play().catch(() => {})
            v.dataset.shouldPlay = '1'
          } else {
            v.pause()
            v.dataset.shouldPlay = ''
          }
        })
      }, { rootMargin: '200px 0px', threshold: 0.05 })
      cardVideos.forEach((el) => lazyVideosObserver.observe(el))

      // If something else (Dawn's pauseAllMedia, drawer open/close, etc.) pauses our videos
      // while they should still be playing, resume them automatically.
      cardVideos.forEach((v) => {
        v.addEventListener('pause', () => {
          if (v.dataset.shouldPlay === '1' && !v.ended) {
            setTimeout(() => { v.muted = true; v.play().catch(() => {}) }, 50)
          }
        })
      })
    }

    // Run twice: once on next frame (early), once after swiper has had a beat to lay out
    requestAnimationFrame(setupCarouselAutoplay)
    setTimeout(setupCarouselAutoplay, 600)
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      spaceBetween: 0,
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

  initReels () {
    this.reelsModal = this.querySelector('.ks-reels-modal')
    if (!this.reelsModal) return
    this.reelsScroller = this.reelsModal.querySelector('[data-scroller]')
    this.reelsMuted = true

    this.reelsModal.querySelector('[data-close-btn]').addEventListener('click', () => this.closeReels())
    this.reelsModal.querySelector('[data-mute-btn]').addEventListener('click', () => this.toggleReelsMute())

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.reelsModal.hasAttribute('open')) this.closeReels()
    })

    // Lazy-instantiate <video> only for items entering viewport (max 3 alive at once).
    // Items further away keep just the poster <img>.
    this._reelsObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const item = entry.target
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          const vid = this.ensureReelVideo(item)
          if (vid) {
            vid.muted = this.reelsMuted
            vid.play().catch(() => {})
          }
        } else {
          const v = item.querySelector('video')
          if (v) v.pause()
        }
      })
    }, { threshold: [0, 0.5, 1] })

    this.reelsModal.querySelectorAll('.ks-reels-modal__item').forEach(item => this._reelsObserver.observe(item))

    // Warm-up: when the user hovers/touches a carousel card, prefetch the corresponding reel
    // video so by the time they tap, it's already buffering.
    const warmReelByIndex = (index) => {
      const item = this.reelsScroller.querySelector(`.ks-reels-modal__item[data-index="${index}"]`)
      if (!item) return
      const src = item.getAttribute('data-video-src')
      if (!src) return
      // Use a hidden <link rel="preload" as="video"> hint so the browser starts fetching
      if (!document.head.querySelector(`link[data-reel-warm="${src}"]`)) {
        const l = document.createElement('link')
        l.rel = 'preload'
        l.as = 'video'
        l.href = src
        l.setAttribute('data-reel-warm', src)
        document.head.appendChild(l)
      }
    }
    this.querySelectorAll('.ks-shoppable-videos-card').forEach((card) => {
      const idx = card.dataset.index
      ;['mouseenter', 'touchstart', 'pointerenter'].forEach((ev) => {
        card.addEventListener(ev, () => warmReelByIndex(idx), { once: true, passive: true })
      })
    })
  }

  ensureReelVideo (item) {
    let vid = item.querySelector('video')
    if (vid) return vid
    const src = item.getAttribute('data-video-src')
    const poster = item.getAttribute('data-video-poster')
    if (!src) return null
    vid = document.createElement('video')
    vid.setAttribute('playsinline', '')
    vid.setAttribute('webkit-playsinline', '')
    vid.muted = true
    vid.loop = true
    vid.controls = false
    vid.preload = 'auto'
    if (poster) vid.poster = poster
    vid.src = src
    // Insert before the product card (so card stays on top via CSS z-index)
    const productCard = item.querySelector('.ks-reels-modal__product')
    if (productCard) item.insertBefore(vid, productCard)
    else item.appendChild(vid)
    // Hide the static poster img once the real video starts playing
    const posterImg = item.querySelector('.ks-reels-modal__poster')
    if (posterImg) {
      vid.addEventListener('playing', () => { posterImg.style.opacity = '0' }, { once: true })
    }
    return vid
  }

  openReels (index) {
    if (!this.reelsModal) return
    this.reelsModal.setAttribute('open', '')
    this.reelsModal.setAttribute('aria-hidden', 'false')
    document.body.classList.add('ks-reels-open')

    this.querySelectorAll('.ks-shoppable-videos-card video').forEach(v => v.pause())

    const target = this.reelsScroller.querySelector(`.ks-reels-modal__item[data-index="${index}"]`)
    if (target) {
      this.reelsScroller.scrollTo({ top: target.offsetTop, behavior: 'instant' in window ? 'instant' : 'auto' })
      // Eagerly create video for the target so playback starts immediately
      const vid = this.ensureReelVideo(target)
      if (vid) {
        vid.muted = this.reelsMuted
        vid.play().catch(() => {})
      }
    }
  }

  closeReels () {
    if (!this.reelsModal) return
    this.reelsModal.removeAttribute('open')
    this.reelsModal.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('ks-reels-open')
    this.reelsModal.querySelectorAll('video').forEach(v => v.pause())
  }

  toggleReelsMute () {
    this.reelsMuted = !this.reelsMuted
    this.reelsModal.querySelectorAll('video').forEach(v => { v.muted = this.reelsMuted })
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches

      const showSelf = () => {
        this.classList.add('show')
        document.body.style.paddingBottom = this.clientHeight + 'px'
      }
      const hideSelf = () => {
        this.classList.remove('show')
        document.body.style.paddingBottom = 0
      }

      const init = () => {
        // Mobile: always visible
        if (isMobile()) {
          showSelf()
        } else {
          const threshold = 200
          if (window.scrollY > threshold) showSelf()
          window.addEventListener('scroll', () => {
            if (isMobile()) { showSelf(); return }
            if (window.scrollY > threshold) showSelf()
            else hideSelf()
          }, { passive: true })
        }

        window.addEventListener('resize', () => {
          if (isMobile()) showSelf()
          else if (window.scrollY <= 200) hideSelf()
        })

        const btnOptions = this.querySelector('.ks-sticky-atc-btn-choose-options')
        const scrollToPicker = () => {
          const picker = document.querySelector('variant-selects') || document.querySelector('product-info')
          picker?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        btnOptions?.addEventListener('click', scrollToPicker)

        // ----- Two-way variant sync between main product-form and sticky-atc form -----
        const stickyForm = this.querySelector('product-form form, form[action*="/cart/add"]')
        if (!stickyForm) return
        const stickyInput = stickyForm.querySelector('[name="id"]')

        const productId = this.dataset.productId
        function getMainForm(){
          // Strictly scope to the MAIN product's <product-info> element so we never sync
          // with related-products / FBT / quick-add forms that belong to other products.
          const info = document.querySelector('product-info[data-product-id="' + productId + '"]')
          if (!info) return null
          return info.querySelector('form[action*="/cart/add"]')
        }

        function syncFromMain(){
          const main = getMainForm()
          if (!main || !stickyInput) return
          const mainInput = main.querySelector('[name="id"]')
          if (mainInput) stickyInput.value = mainInput.value || ''
        }
        // Initial sync (clear if main is empty due to variant guard)
        syncFromMain()

        // Watch the main form's hidden input for value changes
        const mainObserver = new MutationObserver(syncFromMain)
        const mainForm = getMainForm()
        if (mainForm) {
          mainObserver.observe(mainForm, { attributes: true, subtree: true, attributeFilter: ['value'] })
        }
        // Removed redundant 2s safety poll — MutationObserver + change listener cover the path.

        // Listen for variant change events on the document (Dawn fires 'variant:change' or input events)
        document.addEventListener('change', (e) => {
          if (e.target.closest('variant-selects')) {
            // Defer one tick so Dawn finishes updating the main form
            setTimeout(syncFromMain, 50)
          }
        }, true)

        // ----- Guard: open quick-add modal if no variant picked -----
        const isPicked = () => {
          window.__egVariantPicked = window.__egVariantPicked || {}
          return !!window.__egVariantPicked[productId] || (stickyInput && stickyInput.value && stickyInput.value !== '')
        }

        // Read variants BEFORE relocating the modal — the variants <script> lives inside the modal.
        let modal = this.querySelector('[data-ks-modal]')
        let variants = []
        if (modal) {
          try {
            const v = modal.querySelector('[data-ks-variants]')
            if (v) variants = JSON.parse(v.textContent || '[]')
          } catch (e) {}
        }
        // Move the modal out of <ks-sticky-atc> (which has transform applied) into <body>
        // so position:fixed centers against the viewport, not the transformed parent.
        if (modal && modal.parentNode !== document.body) {
          document.body.appendChild(modal)
        }

        const optionPositions = modal ? Array.from(modal.querySelectorAll('[data-option-position]')) : []
        const numOptions = modal ? modal.querySelectorAll('.ks-sticky-quick-modal__option').length : 0
        const selected = {} // position -> value

        const findVariant = () => {
          for (const v of variants) {
            let match = true
            for (let i = 1; i <= numOptions; i++) {
              if (selected[i] !== v['option' + i]) { match = false; break }
            }
            if (match) return v
          }
          return null
        }

        const isOptionValueAvailable = (position, value) => {
          // Check if any variant matching all currently-selected options + this one is available
          const trial = Object.assign({}, selected)
          trial[position] = value
          for (const v of variants) {
            let ok = true
            for (const k in trial) {
              if (trial[k] !== v['option' + k]) { ok = false; break }
            }
            if (ok && v.available) return true
          }
          return false
        }

        const refreshAvailability = () => {
          if (!modal) return
          modal.querySelectorAll('.ks-sticky-quick-modal__pill').forEach(pill => {
            const pos = parseInt(pill.getAttribute('data-option-position'), 10)
            const val = pill.getAttribute('data-option-value')
            const avail = isOptionValueAvailable(pos, val)
            if (!avail) {
              pill.classList.add('is-unavailable')
              pill.setAttribute('disabled', '')
              pill.setAttribute('aria-disabled', 'true')
            } else {
              pill.classList.remove('is-unavailable')
              pill.removeAttribute('disabled')
              pill.removeAttribute('aria-disabled')
            }
          })
        }

        const refreshAtc = () => {
          if (!modal) return
          const atc = modal.querySelector('[data-ks-atc]')
          const allPicked = Object.keys(selected).length === numOptions
          if (allPicked) {
            const v = findVariant()
            if (v && v.available) {
              atc.disabled = false
              atc.dataset.variantId = v.id
            } else {
              atc.disabled = true
              atc.dataset.variantId = ''
            }
          } else {
            atc.disabled = true
            atc.dataset.variantId = ''
          }
        }

        // ----- Read currently-selected option values from the main picker -----
        const readMainSelection = () => {
          const main = document.querySelector('product-info[data-product-id="' + productId + '"]')
          if (!main) return {}
          const sel = {}
          // Pill / swatch pickers (radio buttons grouped per fieldset)
          const fieldsets = main.querySelectorAll('variant-selects fieldset')
          fieldsets.forEach((fs, i) => {
            const checked = fs.querySelector('input[type="radio"]:checked')
            if (checked) sel[i + 1] = checked.value
          })
          // Dropdown pickers
          const dropdowns = main.querySelectorAll('variant-selects .product-form__input--dropdown')
          dropdowns.forEach((dd, i) => {
            const s = dd.querySelector('select')
            if (s && s.value) sel[i + 1 + fieldsets.length] = s.value
          })
          return sel
        }

        // ----- Apply a selection to the modal (visual + state) -----
        const applyToModal = (newSel) => {
          if (!modal) return
          // Don't overwrite the user's in-progress selection while the modal is open —
          // external sources (Dawn section refetch, polling) would race against pill clicks
          // and silently wipe the user's choices, leaving everything looking disabled.
          if (modal.classList.contains('is-open')) return
          let changed = false
          for (const pos in newSel) {
            const value = newSel[pos]
            if (selected[pos] === value) continue
            selected[pos] = value
            changed = true
            modal.querySelectorAll(`.ks-sticky-quick-modal__pill[data-option-position="${pos}"]`).forEach(p => {
              p.classList.toggle('is-active', p.getAttribute('data-option-value') === value)
            })
          }
          if (changed) { refreshAvailability(); refreshAtc() }
        }

        // ----- Apply a selection to the MAIN picker (click radios / set selects) -----
        const applyToMain = (pos, value) => {
          const main = document.querySelector('product-info[data-product-id="' + productId + '"]')
          if (!main) return
          const fieldsets = main.querySelectorAll('variant-selects fieldset')
          const dropdowns = main.querySelectorAll('variant-selects .product-form__input--dropdown')
          const fIdx = parseInt(pos, 10) - 1
          let target = fieldsets[fIdx]
          if (!target) target = dropdowns[fIdx - fieldsets.length]
          if (!target) return
          // Try to find the matching radio
          const radios = target.querySelectorAll('input[type="radio"]')
          let matched = false
          radios.forEach(r => {
            if (r.value === value && !r.disabled) {
              r.checked = true
              r.dispatchEvent(new Event('change', { bubbles: true }))
              matched = true
            }
          })
          if (!matched) {
            const select = target.querySelector('select')
            if (select) {
              select.value = value
              select.dispatchEvent(new Event('change', { bubbles: true }))
            }
          }
        }

        // Listen for any input/change/click on main picker → push into modal
        const onMainChange = () => {
          window.__egVariantPicked = window.__egVariantPicked || {}
          window.__egVariantPicked[productId] = true
          // Multiple deferred reads cover Dawn's async section refetch
          applyToModal(readMainSelection())
          setTimeout(() => applyToModal(readMainSelection()), 100)
          setTimeout(() => applyToModal(readMainSelection()), 400)
          setTimeout(() => applyToModal(readMainSelection()), 900)
        }
        document.addEventListener('change', (e) => {
          if (e.target.closest('product-info[data-product-id="' + productId + '"] variant-selects')) onMainChange()
        }, true)
        document.addEventListener('click', (e) => {
          const t = e.target.closest('product-info[data-product-id="' + productId + '"] variant-selects label, product-info[data-product-id="' + productId + '"] variant-selects input[type="radio"]')
          if (t) onMainChange()
        }, true)

        // Watch the main product-info for DOM changes (Dawn replaces the variant-selects on each pick)
        const mainInfoEl = document.querySelector('product-info[data-product-id="' + productId + '"]')
        if (mainInfoEl) {
          new MutationObserver(() => applyToModal(readMainSelection())).observe(mainInfoEl, { childList: true, subtree: true })
        }
        // Removed 3s safety poll — MutationObserver + change events already cover the path.
        // Initial sync
        applyToModal(readMainSelection())

        if (modal) {
          modal.addEventListener('click', (e) => {
            if (e.target === modal || e.target.closest('[data-ks-close]')) {
              modal.classList.remove('is-open')
              document.body.classList.remove('ks-sticky-modal-open')
              // Clear any pending intent + re-enable the modal CTA so the next open is clean
              window.__egVariantIntent = null
              window.__egShiprocketTrigger = null
              const cta = modal.querySelector('[data-ks-atc]')
              if (cta) {
                cta.disabled = false
                const lbl = cta.querySelector('[data-ks-atc-label]')
                if (lbl && cta.dataset.origLabel) lbl.textContent = cta.dataset.origLabel
              }
              return
            }
            const pill = e.target.closest('.ks-sticky-quick-modal__pill')
            if (pill && !pill.disabled) {
              const pos = parseInt(pill.getAttribute('data-option-position'), 10)
              const val = pill.getAttribute('data-option-value')
              selected[pos] = val
              modal.querySelectorAll(`.ks-sticky-quick-modal__pill[data-option-position="${pos}"]`).forEach(p => p.classList.remove('is-active'))
              pill.classList.add('is-active')
              refreshAvailability()
              refreshAtc()
              // NOTE: do NOT call applyToMain() here — it dispatches change events on Dawn's
              // variant-selects which kick off an async section refetch. The MutationObserver
              // then races with our local `selected` state and can wipe pill selections /
              // disable everything. Sync to main form ONLY at submit time (below), and only
              // when the intent actually requires Dawn + Shiprocket to know the variant.
              window.__egVariantPicked = window.__egVariantPicked || {}
              window.__egVariantPicked[productId] = true
              return
            }
            const atcBtn = e.target.closest('[data-ks-atc]')
            if (atcBtn && !atcBtn.disabled) {
              const vid = atcBtn.dataset.variantId
              if (!vid) return
              // Mark picked + sync sticky input + close modal + submit
              window.__egVariantPicked = window.__egVariantPicked || {}
              window.__egVariantPicked[productId] = true
              if (stickyInput) stickyInput.value = vid
              // Also sync main form
              const main = getMainForm()
              if (main) {
                const mInp = main.querySelector('[name="id"]')
                if (mInp) mInp.value = vid
              }
              modal.classList.remove('is-open')
              document.body.classList.remove('ks-sticky-modal-open')
              atcBtn.disabled = true
              const origLabel = atcBtn.querySelector('[data-ks-atc-label]')?.textContent
              if (origLabel) atcBtn.querySelector('[data-ks-atc-label]').textContent = 'Adding…'
              const intent = window.__egVariantIntent;

              // Buy-now intents (our overlay OR Shiprocket capture) — third-party SDKs
              // (Shiprocket) require an in-gesture click. Re-querying the trigger at click time
              // because Dawn's section refetch may have replaced the original button reference.
              if (intent === 'buy' || intent === 'shiprocket') {
                window.__egVariantIntent = null;
                window.__egShiprocketTrigger = null;

                // Re-fire applyToMain so Dawn (and Shiprocket's listeners) see real change events.
                Object.keys(selected).forEach(pos => applyToMain(parseInt(pos, 10), selected[pos]));

                // Force the form's hidden id input + dispatch its own change event in case
                // Shiprocket listens specifically to the [name="id"] input rather than radios.
                const mainForLater = getMainForm();
                if (mainForLater) {
                  const idInp = mainForLater.querySelector('[name="id"]');
                  if (idInp) {
                    idInp.value = vid;
                    idInp.dispatchEvent(new Event('change', { bubbles: true }));
                    idInp.dispatchEvent(new Event('input', { bubbles: true }));
                  }
                }

                // Find the LIVE Shiprocket button now (may have been replaced by Dawn's refetch)
                const liveTrigger = document.querySelector('product-form[data-section-id="' + (mainForLater?.closest('product-form')?.dataset.sectionId || '') + '"] .sr-headless-checkout')
                  || document.querySelector('.sr-headless-checkout')
                  || document.querySelector('.shiprocket-headless button');

                console.log('[EG] Modal CTA → Shiprocket trigger:', liveTrigger, 'variant:', vid);

                if (liveTrigger) {
                  liveTrigger.__egReFired = true;
                  // Native click in the same user gesture — works for popups/iframes
                  try { liveTrigger.click(); }
                  catch (e1) {
                    console.error('[EG] trigger.click() threw:', e1);
                    try { if (typeof liveTrigger.onclick === 'function') liveTrigger.onclick(new Event('click', { bubbles: true, cancelable: true })); }
                    catch (e2) { console.error('[EG] onclick threw:', e2); window.location.href = '/checkout'; }
                  }
                } else if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyProduct === 'function') {
                  console.log('[EG] No DOM trigger — calling shiprocketCheckoutEvents.buyProduct directly');
                  try { window.shiprocketCheckoutEvents.buyProduct({ currentTarget: null, target: null, preventDefault(){}, stopPropagation(){} }); }
                  catch (e3) { console.error('[EG] shiprocketCheckoutEvents threw:', e3); window.location.href = '/checkout'; }
                } else {
                  console.warn('[EG] No Shiprocket button found — falling back to /checkout');
                  window.location.href = '/checkout';
                }
                atcBtn.disabled = false;
                if (origLabel) atcBtn.querySelector('[data-ks-atc-label]').textContent = origLabel;
                return;
              }

              const cartDrawer = document.querySelector('cart-drawer');
              const sectionsToRender = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
                ? cartDrawer.getSectionsToRender().map(s => s.section || s.id)
                : ['cart-drawer', 'cart-icon-bubble'];

              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  items: [{ id: parseInt(vid, 10), quantity: getMainQty() }],
                  sections: sectionsToRender,
                  sections_url: window.location.pathname
                })
              })
              .then(r => r.json())
              .then(parsedState => {
                if (parsedState && parsedState.status && parsedState.status >= 400) {
                  throw new Error(parsedState.description || parsedState.message || 'Cart error');
                }

                // Use Dawn's own renderContents — it knows the correct selectors and opens the drawer
                if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState && parsedState.sections) {
                  cartDrawer.renderContents(parsedState);
                  // Dawn only strips is-empty from .drawer__inner; the class lives on <cart-drawer>
                  // and <cart-drawer-items>. Strip them so empty→populated transitions render.
                  cartDrawer.classList.remove('is-empty');
                  const cdItems = document.querySelector('cart-drawer-items');
                  if (cdItems) cdItems.classList.remove('is-empty');
                } else {
                  // Fallback: nothing safe to do client-side; redirect to /cart
                  window.location.href = '/cart';
                  return;
                }

                if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
                  try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-atc' }); } catch (e) {}
                }

                window.__egVariantIntent = null;
                atcBtn.disabled = false;
                if (origLabel) atcBtn.querySelector('[data-ks-atc-label]').textContent = origLabel;
              })
              .catch((err) => {
                console.error('Sticky ATC add error:', err);
                atcBtn.disabled = false;
                if (origLabel) atcBtn.querySelector('[data-ks-atc-label]').textContent = origLabel;
                alert('Could not add to cart.');
              })
            }
          })
        }

        // ----- Read quantity from main product-form -----
        function getMainQtyInput(){
          const main = getMainForm()
          if (!main) return null
          return main.querySelector('[name="quantity"]')
        }
        function getMainQty(){
          const mainInput = getMainQtyInput()
          let q = mainInput ? parseInt(mainInput.value, 10) : 1
          if (isNaN(q) || q < 1) q = 1
          if (mainInput) {
            const min = parseInt(mainInput.getAttribute('min'), 10)
            const max = parseInt(mainInput.getAttribute('max'), 10)
            if (!isNaN(min) && q < min) q = min
            if (!isNaN(max) && q > max) q = max
          }
          return q
        }

        const openModal = () => {
          if (!modal) return
          // Reset state
          for (const k in selected) delete selected[k]
          modal.querySelectorAll('.ks-sticky-quick-modal__pill').forEach(p => p.classList.remove('is-active'))
          refreshAvailability()
          refreshAtc()
          // Swap CTA label based on intent (Buy Now / Shiprocket / Add to cart)
          const ctaLabelEl = modal.querySelector('[data-ks-atc-label]')
          if (ctaLabelEl) {
            const it = window.__egVariantIntent
            ctaLabelEl.textContent = (it === 'buy' || it === 'shiprocket') ? 'Buy it now' : 'Add to cart'
          }
          modal.removeAttribute('hidden')
          modal.style.display = ''
          modal.classList.add('is-open')
          document.body.classList.add('ks-sticky-modal-open')
        }

        // Public API: anyone (e.g. main product ATC) can call this to open the same picker modal
        this.openQuickAddModal = openModal

        // Global event hook — main product ATC dispatches `eg:require-variant` when clicked without a picked variant
        document.addEventListener('eg:require-variant', (ev) => {
          if (!modal) return
          if (ev && ev.detail && ev.detail.productId && String(ev.detail.productId) !== String(productId)) return
          openModal()
        })

        const blocker = (e) => {
          if (isPicked()) return
          e.preventDefault()
          e.stopImmediatePropagation()
          // Sticky ATC opens the modal in plain ATC mode — clear any leftover buy/shiprocket
          // intent from a prior dismissed-without-completing flow, otherwise the modal CTA
          // would try to re-fire Shiprocket with a stale trigger and leave everything disabled.
          window.__egVariantIntent = null
          window.__egShiprocketTrigger = null
          if (modal) openModal()
          else scrollToPicker()
        }
        stickyForm.addEventListener('submit', blocker, true)
        const submitBtn = stickyForm.querySelector('button[type="submit"], button[name="add"]')
        if (submitBtn) submitBtn.addEventListener('click', blocker, true)
        // Also block the Choose options button to open the modal
        if (btnOptions && modal) {
          btnOptions.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopImmediatePropagation()
            openModal()
          }, true)
        }
      }

      // Run on connected, but also defer slightly so layout is settled
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
      } else {
        requestAnimationFrame(init)
      }
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();
})();
